import React, { Component } from 'react';
import { Styles } from './styles/contact.js';

class GoogleMap extends Component {

    render() {
        return (
            <Styles>
                {/* Google Map */}
                <div className="google-map-area mt-5">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3459.8470337259323!2d77.8797646!3d29.868684999999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390eb30017f30a21%3A0x9bc996ecd99986f3!2sERP%20TECH%20PRO!5e0!3m2!1sen!2sin!4v1776250208475!5m2!1sen!2sin"
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Care University Location"
                    ></iframe>
                </div>
            </Styles>
        )
    }
}

export default GoogleMap;